<template>
  <div>
    <van-sticky>
      <van-nav-bar :border="false">
        <template #left>
          <span class="iconfont icon-houtui fs-24 fw-700" @click="$router.back()"></span>
        </template>
        <template #title>
          <strong>关于三咖</strong>
        </template>
      </van-nav-bar>
    </van-sticky>
    <div class="header">
      <img :src="require('@/assets/logo.png')" alt="">
      <h2>三咖音乐全球通</h2>
      <p v-show="isPlus">Version {{ userInfo.android_version || '2.2.2' }}</p>
    </div>
    <van-cell title="功能介绍" to="/feature-list" is-link />
    <van-cell title="问题反馈" to="/feedback" is-link />
    <van-cell title="帮助中心" to="/help/list" is-link />
    <van-cell v-show="isPlus" title="检查新版本" is-link @click="checkVersion" />
    <div class="footer">
      <router-link to="/help/detail?pid=2&id=5&title=平台使用协议">三咖音乐软件许可及服务协议</router-link><br>
      <router-link to="/help/detail?pid=2&id=22&title=隐私政策">《隐私保护指引》</router-link>
      <p class="color-B7BDCA">Copyright © 2017 - 2020 KKKMusic.All Rights Reserved. </p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'About',
  computed: {
    ...mapState(['userInfo', 'isPlus'])
  },
  methods: {
    checkVersion() {
      this.$toast.loading({
        message: '检测中...',
        loadingType: 'spinner',
        forbidClick: true,
        duration: 2000
      })
      setTimeout(() => {
        this.$toast('已是最新版本！')
      }, 2000)
    }
  }
}
</script>

<style lang="scss" scoped>
.header{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 0;
  img{
    width: 80px;
    height: 80px;
  }
  h2{
    font-size: 20px;
    margin: 30px 0 0px;
  }
  p{
    font-size: 14px;
    line-height: 24px;
  }
}
.footer{
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  font-size: 12px;
  a{
    color: #12549d;
  }
}
</style>
